var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote"},[_c('img',{staticClass:"quote-img",attrs:{"src":require("@/assets/quote.png"),"alt":""}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.quote))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ea25602","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Quote.vue
// module id = null
// module chunks = 